import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';
import es from './locales/es.json';

// ─── DEFAULT LANGUAGE ────────────────────────────────────────────────────────
// Change 'ar' below to 'en', 'fr', or 'es' to pick a different default.
// This is only used when the user has never chosen a language before.
const DEFAULT_LANGUAGE = 'ar';
// ─────────────────────────────────────────────────────────────────────────────

const savedLanguage = localStorage.getItem('i18nextLng');

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      ar: { translation: ar },
      es: { translation: es },
    },
    lng: savedLanguage || DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Persist the user's language choice so it survives page reloads
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;
